import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';

export default function RouteWithSubRoutes({ route, ...rest }) {
  return (
    <Route
      path={route.path}
      render={props => <route.component {...props} routes={route.routes} {...rest} />}
    />
  );
}

const routeType = {
  path: PropTypes.string.isRequired,
  component: PropTypes.any,
};

const routeWithSubRoutesType = {
  ...routeType,
  routes: PropTypes.arrayOf(PropTypes.shape(routeType)),
};

RouteWithSubRoutes.propTypes = {
  route: PropTypes.shape(routeWithSubRoutesType).isRequired,
};
